module.exports = __webpack_public_path__ + "images/d18b9d364a7800a08e69521d7f1c353994e90a7556f8762774e261c6f08f9a8a.svg";